import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 25px;
`;

export const Input = styled.input`
  flex: 1;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-family: "League Spartan", sans-serif;
  font-size: 16px;
  background: white;
  outline: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: #666;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 18px;
  border-radius: 8px;
  border: none;
  background: #222;
  color: white;
  cursor: pointer;
  font-family: "League Spartan", sans-serif;
  font-size: 16px;
  font-weight: 300;
  transition: 0.3s;

  &:hover {
    background: #000;
  }
`;
